import { useEffect, useState } from "react";
import { lang } from "src/language/Strings";
import { useForm } from "src/api/hooks/useForm";
import { useParams } from "react-router-dom";
import { ItemDescription } from "src/components/ItemDescription";
import { CompanyResponse } from "src/types/CompanyResponse";
import { useCompanyById } from "src/api/hooks/useCompanyById";
import { useCompanyApis } from "src/api/hooks/useCompanyApis";

export function CompanyPage() {
  const { companyId } = useParams();
  const { data: company } = useCompanyById(companyId!);
  useState<CompanyResponse | null>(null);
  const { data: companyApis } = useCompanyApis(companyId!);

  const { Form, formData, setFormData } = useForm<CompanyResponse>({
    address: "",
    zipCode: "",
    organisationNumber: "",
    city: "",
    name: "",
    country: "",
  });
  useEffect(() => {
    if (company) {
      setFormData(company);
    }
  }, [company]);

  return (
    <div className="flex flex-col h-full relative w-full ">
      <div className="flex flex-row w-full p-2">
        <div className="h-full w-full overflow-y-auto">
          <Form id="groupForm">
            <ItemDescription label={lang.group}>
              <Form.Input name="name" defaultValue={formData.name} />
            </ItemDescription>

            <ItemDescription label={lang.companyName}>
              <Form.Input name="name" defaultValue={formData.name} />
            </ItemDescription>
            <ItemDescription label={lang.organizationNumber}>
              <Form.Input
                name="organisationNumber"
                defaultValue={formData.organisationNumber}
              />
            </ItemDescription>
            <ItemDescription label={lang.address}>
              <Form.Input name="address" defaultValue={formData.address} />
            </ItemDescription>
            <ItemDescription label={lang.zipCode}>
              <Form.Input name="zipCode" defaultValue={formData.zipCode} />
            </ItemDescription>
            <ItemDescription label={lang.city}>
              <Form.Input name="city" defaultValue={formData.city} />
            </ItemDescription>
            <ItemDescription label={lang.country}>
              <Form.Input name="country" defaultValue={formData.country} />
            </ItemDescription>
            <ItemDescription
              label={lang.apiCredentials}
              className="overflow-y-auto"
            >
              {companyApis?.map((api: any) => {
                return <div></div>;
              })}
            </ItemDescription>
          </Form>
        </div>
      </div>
    </div>
  );
}
